import { useCallback, useMemo } from 'react';

import { IUseQueryProps } from 'store/queries/types';
import { getQueryParams } from 'store/utils/getQueryParams';
import { useAppSelector } from 'store/useAppSelector';

import {
  IFetchStandardAccountJWTProps,
  selectStandardAccountJWT,
  selectStandardAccountJWTLoading,
  selectStandardAccountJWTState,
  useFetchStandardAccountJWTQuery,
  useLazyFetchStandardAccountJWTQuery,
} from '../fetchStandardAccountJWT';

export interface IUseStandardAccountJWTQueryProps
  extends IUseQueryProps,
    IFetchStandardAccountJWTProps {}

export const useStandardAccountJWTQuery = ({
  skipFetching,
  totp,
}: IUseStandardAccountJWTQueryProps) => {
  const params = useMemo(
    (): IFetchStandardAccountJWTProps => ({ params: undefined, totp }),
    [totp],
  );

  useFetchStandardAccountJWTQuery(getQueryParams({ params, skipFetching }));

  const [fetchLazy] = useLazyFetchStandardAccountJWTQuery();

  const handleFetchStandardAccountJWT = useCallback(
    () => fetchLazy(params),
    [fetchLazy, params],
  );

  const standardAccountJWT = useAppSelector(state =>
    selectStandardAccountJWT(state, params),
  );

  const loading = useAppSelector(state =>
    selectStandardAccountJWTLoading(state, params),
  );

  const state = useAppSelector(storeState =>
    selectStandardAccountJWTState(storeState, params),
  );

  return {
    handleFetchStandardAccountJWT,
    loading,
    params,
    standardAccountJWT,
    state,
  };
};
